var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPetrol(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.8734 23.6605C17.119 23.6605 16.9063 22.0123 16.9063 21.0552C16.9063 20.0982 16.9063 14.3558 16.9063 13.6115C16.9063 12.8671 17.0127 12.7607 16.4278 12.7607C16.2365 12.7607 16.0982 12.7607 16.0025 12.7607V23.7669H17.5975V26H0V23.7669H1.70127V1.06339C1.70127 0.478528 2.17975 0 2.76456 0H14.9392C15.5241 0 16.0025 0.478528 16.0025 1.06339V3.80695C16.4385 4.1047 19.4476 6.18896 19.9899 6.59305C20.5747 7.0184 21 7.23108 21 8.87935C21 10.5276 21 20.0982 21 21.2679C21 22.4376 20.6278 23.6605 18.8734 23.6605ZM14.2481 2.92434C14.2481 2.33947 13.7696 1.86094 13.1848 1.86094H4.51899C3.93418 1.86094 3.4557 2.33947 3.4557 2.92434V8.02863C3.4557 8.6135 3.93418 9.09202 4.51899 9.09202H13.1848C13.7696 9.09202 14.2481 8.6135 14.2481 8.02863V2.92434ZM19.4582 10.4213C19.4582 9.57055 18.8734 9.67689 18.3418 9.67689C17.8101 9.67689 16.9595 9.67689 16.9595 9.67689V6.22086L16.0025 5.66789V11.2188H17.2785C18.1291 11.2188 18.4481 11.3252 18.4481 12.6012C18.4481 13.8773 18.4481 20.2577 18.4481 21.1084C18.4481 21.9591 18.5544 22.0654 18.9266 22.0654C19.2987 22.0654 19.4582 21.7996 19.4582 21.1616C19.4582 20.5235 19.4582 11.272 19.4582 10.4213Z",
    fill: "url(#paint0_linear_740_6216)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_740_6216",
    x1: 4.85873,
    y1: 14.7001,
    x2: 20.8491,
    y2: 14.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4C221"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FBB640"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPetrol);
export default __webpack_public_path__ + "static/media/petrol.ce0933b1a3bb42d43bc3c9afa0e42dd0.svg";
export { ForwardRef as ReactComponent };